import * as React from 'react';
import { Member, MemberContext } from '@contexts/member/MemberContext';
import { useAppSetting } from '@contexts/appSetting/hooks/useAppSetting';

export type WithMemberContext<A> = {
    member: Member | null;
} & A;

export function withMemberContext<TProps>(Component: React.FC<TProps>): React.FC<WithMemberContext<TProps>> {
    const ComponentWithMemberContext: React.FC<WithMemberContext<TProps>> = props => {
        const { feature } = useAppSetting();
        const [member, setMember] = React.useState<Member | null>(feature.l1Login ? props.member : null);

        return (
            <MemberContext.Provider value={{ member, setMember }}>
                <Component {...props} />
            </MemberContext.Provider>
        );
    };

    ComponentWithMemberContext.displayName = `${Component.displayName || 'Component'}WithMemberContext`;

    return ComponentWithMemberContext;
}
